import { juvareColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Button, ButtonGroup, FormControl, IconButton, MenuItem, Select, useMediaQuery, } from '@mui/material';
import React from 'react';
import { missionTypeEntityName } from '../../../../backend/config/classifiers';
import { missionStatuses, missionStatusesVisibleToVolunteer } from '../../../../backend/extraTypes';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { getMissionStatusLabel } from '../../../../ui/utils/getMissionStatusLabel';
import { showAllMissions } from '../constants';
export const MissionPageToolbar = (props) => {
    var _a, _b;
    const [selectedMissionStatusFilter, setSelectedMissionStatusFilter] = React.useState(showAllMissions);
    const [selectedMissionTypeFilter, setSelectedMissionTypeFilter] = React.useState(showAllMissions);
    const [missionTypeFilterItems, setMissionTypeFilterItems] = React.useState({ rows: [], total: 0 });
    const missionTypeStorage = useStorageClient(missionTypeEntityName);
    const { t } = useMissionsTranslation();
    const upMdScreen = useMediaQuery((theme) => theme.breakpoints.up('md'));
    const downSmScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const fetchMissionTypeItems = React.useCallback(() => {
        missionTypeStorage
            .list({ filter: [{ column: 'status', op: '=', value: 'active' }] })
            .then((response) => setMissionTypeFilterItems(response))
            .catch(handleErrorSnackbar);
    }, [missionTypeStorage]);
    React.useEffect(() => {
        fetchMissionTypeItems();
    }, [fetchMissionTypeItems]);
    const onFilterChange = (e, column) => {
        props.onApplyFilter(column, e.target.value);
    };
    const clearAllFilters = () => {
        setSelectedMissionStatusFilter(showAllMissions);
        setSelectedMissionTypeFilter(showAllMissions);
        props.onClearFilters();
    };
    return (React.createElement(Box, { sx: [
            { display: 'flex', pt: 2, px: 4 },
            downSmScreen
                ? { flexDirection: 'column', alignItems: 'center', width: '100%' }
                : upMdScreen
                    ? { flexDirection: 'row', alignItems: 'center' }
                    : { flexDirection: 'column-reverse', gap: 3 },
        ] },
        React.createElement(Box, { sx: [
                {
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                },
                downSmScreen ? { flexDirection: 'column', width: '100%' } : { flexDirection: 'row', flexGrow: 1 },
            ] },
            React.createElement(ButtonGroup, { variant: 'outlined', sx: [downSmScreen && { width: '100%' }] },
                React.createElement(Button, { fullWidth: true, size: 'large', onClick: () => {
                        props.onSortBy('createdAt', true);
                    }, "data-test": 'sort-by-date-button', sx: {
                        backgroundColor: ((_a = props.sortBy) === null || _a === void 0 ? void 0 : _a.column) === 'createdAt' ? juvareColors.blue['700-10p'] : undefined,
                    } }, t('missions.toolbar.sortByDate')),
                React.createElement(Button, { fullWidth: true, size: 'large', onClick: () => {
                        props.onSortBy('name');
                    }, "data-test": 'sort-by-name-button', sx: {
                        backgroundColor: ((_b = props.sortBy) === null || _b === void 0 ? void 0 : _b.column) === 'name' ? juvareColors.blue['700-10p'] : undefined,
                    } }, t('missions.toolbar.sortByName'))),
            React.createElement(FormControl, { sx: { minWidth: 156 }, size: 'small', fullWidth: true },
                React.createElement(Select, { value: selectedMissionStatusFilter, "data-test": 'filter-mission-status', onChange: (e) => {
                        setSelectedMissionStatusFilter(e.target.value);
                        onFilterChange(e, 'status');
                    } },
                    React.createElement(MenuItem, { key: 'showAll', value: showAllMissions }, t('missions.toolbar.showAllStatuses')),
                    !props.allowMissionChange
                        ? missionStatusesVisibleToVolunteer.map((status) => (React.createElement(MenuItem, { key: status, value: status }, getMissionStatusLabel(t, status, false))))
                        : missionStatuses.map((status) => (React.createElement(MenuItem, { key: status, value: status }, getMissionStatusLabel(t, status, true)))))),
            React.createElement(FormControl, { sx: { minWidth: 156 }, size: 'small', fullWidth: true },
                React.createElement(Select, { onChange: (e) => {
                        setSelectedMissionTypeFilter(e.target.value);
                        onFilterChange(e, 'typeId');
                    }, value: selectedMissionTypeFilter, "data-test": 'filter-mission-type' },
                    React.createElement(MenuItem, { key: 'showAll', value: showAllMissions }, t('missions.toolbar.showAllTypes')),
                    missionTypeFilterItems.rows.map((missionType) => (React.createElement(MenuItem, { value: missionType.id, key: missionType.id }, missionType.columns.name))))),
            React.createElement(IconButton, { onClick: clearAllFilters, "aria-label": t('ariaLabels.clearFilters'), "data-test": 'clear-filters-button', sx: [downSmScreen ? { alignSelf: 'flex-end' } : { px: 1 }] },
                React.createElement(ReplayIcon, { color: 'primary' }))),
        React.createElement(Box, { sx: [
                {
                    display: 'flex',
                    flexGrow: 3,
                    justifyContent: 'flex-end',
                },
                downSmScreen && { width: '100%' },
            ] }, props.actions)));
};
